// Bruce Clay silo URL builder for Heather's Boutique products.
// URL shape (updated):
//   Category hub:  /{category_slug}                    (e.g. /prom-dresses)
//   Brand hub:     /brand/{brand_slug}                 (one URL per brand, cross-category)
//   Product page:  /{category_slug}/{product_slug}     (product_slug includes brand-sku-name)
//   Per-color:     /{category_slug}/{product_slug}/{color_slug}

export function slugify(str) {
  return String(str || "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase()
    .replace(/-+/g, "-");
}

export function categorySlugFor(product) {
  if (!product) return "prom-dresses";
  if (product.category_slug) return product.category_slug;
  const occ = (product.occasion || "").toLowerCase();
  if (occ === "homecoming") return "homecoming-dresses";
  if (occ === "graduation") return "graduation-dresses";
  return "prom-dresses";
}

export function brandSlugFor(product) {
  if (!product) return "atelier";
  if (product.brand_slug) return product.brand_slug;
  return slugify(product.designer || "atelier") || "atelier";
}

export function productSlugFor(product) {
  if (!product) return "";
  if (product.slug) return product.slug;
  return slugify(product.handle || product.name || "");
}

/**
 * Build the canonical URL for a product (optionally per-color).
 * Falls back to legacy /product/{id} if we lack slug data.
 */
export function productUrl(product, color) {
  if (!product) return "#";
  if (product.url) {
    const base = product.url;
    if (color) {
      const cs = slugify(color);
      if (cs) return `${base}/${cs}`;
    }
    return base;
  }
  const c = categorySlugFor(product);
  const s = productSlugFor(product);
  if (!c || !s) return `/product/${product.id}`;
  const base = `/${c}/${s}`;
  if (color) {
    const cs = slugify(color);
    if (cs) return `${base}/${cs}`;
  }
  return base;
}

export function categoryUrl(categorySlug) {
  return `/${categorySlug}`;
}

export function brandUrl(brandSlug) {
  // Cross-category — one URL per brand.
  return `/brand/${brandSlug}`;
}

export function categoryLabel(slug) {
  return (
    {
      "prom-dresses": "Prom Dresses",
      "homecoming-dresses": "Homecoming Dresses",
      "graduation-dresses": "Graduation Dresses",
      "tuxedos": "Tuxedos & Suits",
      "accessories": "Accessories",
      "shoes": "Shoes",
    }[slug] || (slug || "").replace(/-/g, " ").replace(/\b\w/g, (m) => m.toUpperCase())
  );
}
